import React, { useState } from 'react';

const FamilyMemberForm = ({ onAddMember, onClose }) => {
  const [formData, setFormData] = useState({
    fullName: '',
    isibongo: '',
    praiseNames: '',
    relationship: '',
    birthDate: '',
    deathDate: '',
    lifeEvents: '',
    photo: null
  });

  const zuluRelationships = [
    { value: 'uBaba', label: 'uBaba (Father)' },
    { value: 'uMama', label: 'uMama (Mother)' },
    { value: 'Umkhulu', label: 'Umkhulu (Grandfather)' },
    { value: 'Ugogo', label: 'Ugogo (Grandmother)' },
    { value: 'uMzala', label: 'uMzala (Cousin)' },
    { value: 'uMalume', label: 'uMalume (Uncle - Mother\'s brother)' },
    { value: 'uBhuti', label: 'uBhuti (Brother)' },
    { value: 'uSisi', label: 'uSisi (Sister)' },
    { value: 'iNdodana', label: 'iNdodana (Son)' },
    { value: 'iNdodakazi', label: 'iNdodakazi (Daughter)' }
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!formData.fullName || !formData.relationship) {
      alert('Please fill in at least the name and relationship');
      return;
    }

    const newMember = {
      id: Date.now(),
      ...formData,
      createdAt: new Date().toISOString()
    };

    onAddMember(newMember);
    
    setFormData({
      fullName: '',
      isibongo: '',
      praiseNames: '',
      relationship: '',
      birthDate: '',
      deathDate: '',
      lifeEvents: '',
      photo: null
    });
  };

  return (
    <div style={{ 
      position: 'fixed', 
      top: 0, 
      left: 0, 
      right: 0, 
      bottom: 0, 
      backgroundColor: 'rgba(0,0,0,0.5)', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      zIndex: 1000
    }}>
      <div style={{ 
        backgroundColor: 'white', 
        padding: '24px', 
        borderRadius: '8px', 
        width: '100%', 
        maxWidth: '500px',
        maxHeight: '90vh',
        overflowY: 'auto'
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
          <h2 style={{ fontSize: '20px', fontWeight: 'bold', color: '#92400e' }}>
            Engeza Umndeni (Add Family Member)
          </h2>
          <button onClick={onClose} style={{ fontSize: '24px', background: 'none', border: 'none' }}>×</button>
        </div>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '16px' }}>
            <label style={{ display: 'block', marginBottom: '4px', fontWeight: '500' }}>
              Igama Eliphelele (Full Name) *
            </label>
            <input
              type="text"
              name="fullName"
              value={formData.fullName}
              onChange={handleInputChange}
              style={{ 
                width: '100%', 
                padding: '8px', 
                border: '1px solid #ccc', 
                borderRadius: '4px' 
              }}
              placeholder="Enter full name"
              required
            />
          </div>

          <div style={{ marginBottom: '16px' }}>
            <label style={{ display: 'block', marginBottom: '4px', fontWeight: '500' }}>
              Isibongo (Clan/Surname)
            </label>
            <input
              type="text"
              name="isibongo"
              value={formData.isibongo}
              onChange={handleInputChange}
              style={{ 
                width: '100%', 
                padding: '8px', 
                border: '1px solid #ccc', 
                borderRadius: '4px' 
              }}
              placeholder="e.g., Mthembu, Nkomo, Zulu"
            />
          </div>

          <div style={{ marginBottom: '16px' }}>
            <label style={{ display: 'block', marginBottom: '4px', fontWeight: '500' }}>
              Ubudlelwano (Relationship) *
            </label>
            <select
              name="relationship"
              value={formData.relationship}
              onChange={handleInputChange}
              style={{ 
                width: '100%', 
                padding: '8px', 
                border: '1px solid #ccc', 
                borderRadius: '4px' 
              }}
              required
            >
              <option value="">Select relationship</option>
              {zuluRelationships.map(rel => (
                <option key={rel.value} value={rel.value}>{rel.label}</option>
              ))}
            </select>
          </div>

          <div style={{ marginBottom: '16px' }}>
            <label style={{ display: 'block', marginBottom: '4px', fontWeight: '500' }}>
              Usuku Lokuzalwa (Birth Date)
            </label>
            <input
              type="date"
              name="birthDate"
              value={formData.birthDate}
              onChange={handleInputChange}
              style={{ 
                width: '100%', 
                padding: '8px', 
                border: '1px solid #ccc', 
                borderRadius: '4px' 
              }}
            />
          </div>

          <div style={{ marginBottom: '16px' }}>
            <label style={{ display: 'block', marginBottom: '4px', fontWeight: '500' }}>
              Izehlakalo Zokuphila (Life Events & Roles)
            </label>
            <textarea
              name="lifeEvents"
              value={formData.lifeEvents}
              onChange={handleInputChange}
              rows="3"
              style={{ 
                width: '100%', 
                padding: '8px', 
                border: '1px solid #ccc', 
                borderRadius: '4px' 
              }}
              placeholder="e.g., Built homestead, Family leader, Teacher, etc."
            />
          </div>

          <div style={{ display: 'flex', gap: '12px', marginTop: '24px' }}>
            <button
              type="submit"
              style={{
                flex: 1,
                backgroundColor: '#d97706',
                color: 'white',
                padding: '12px',
                border: 'none',
                borderRadius: '6px',
                cursor: 'pointer'
              }}
            >
              Engeza (Add Member)
            </button>
            <button
              type="button"
              onClick={onClose}
              style={{
                flex: 1,
                backgroundColor: '#6b7280',
                color: 'white',
                padding: '12px',
                border: 'none',
                borderRadius: '6px',
                cursor: 'pointer'
              }}
            >
              Khansela (Cancel)
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default FamilyMemberForm;